
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ja"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.json", load: () => import("../locales/en.json" /* webpackChunkName: "locale__home_runner_work_ss_bonsai_admin_frontend_ss_bonsai_admin_frontend_locales_en_json" */), cache: true }],
  "ja": [{ key: "../locales/ja.json", load: () => import("../locales/ja.json" /* webpackChunkName: "locale__home_runner_work_ss_bonsai_admin_frontend_ss_bonsai_admin_frontend_locales_ja_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "en",
      "language": "en_US",
      "files": [
        "/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/locales/en.json"
      ]
    },
    {
      "code": "ja",
      "language": "ja_JP",
      "files": [
        "/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/locales/ja.json"
      ]
    }
  ],
  "defaultLocale": "ja",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "locales/",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en_US",
    "files": [
      {
        "path": "/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/locales/en.json"
      }
    ]
  },
  {
    "code": "ja",
    "language": "ja_JP",
    "files": [
      {
        "path": "/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/locales/ja.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
